import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const CHUNK_SIZE = 4 * 1024 * 1024;
export async function uploadFile(file, onProgress) {
  if (file.size <= CHUNK_SIZE) {
    const fd = new FormData();
    fd.append("file", file);
    const res = await api.post("/admin/upload", fd, {
      onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded / (e.total || file.size)) * 100)),
    });
    return res.data;
  }
  const { data: init } = await api.post("/admin/upload/init", { filename: file.name });
  const uploadId = init.upload_id;
  const total = Math.ceil(file.size / CHUNK_SIZE);
  for (let i = 0; i < total; i++) {
    const chunk = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
    await api.put(`/admin/upload/chunk?upload_id=${uploadId}&index=${i}`, chunk, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    onProgress && onProgress(Math.round(((i + 1) / total) * 100));
  }
  const { data } = await api.post("/admin/upload/complete", { upload_id: uploadId });
  return data;
}

export function fileDownloadUrl(fileId, opts = {}) {
  const token = localStorage.getItem("np_token");
  const q = opts.download ? "&download=1" : "";
  return `${API}/files/${fileId}/download?auth=${token}${q}`;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("np_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
